import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, mergeProps as _mergeProps, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "position-relative s-mobile-input",
  dir: "ltr"
}
const _hoisted_2 = { class: "svg-35px" }
const _hoisted_3 = {
  key: 0,
  class: "svg-30px"
}
const _hoisted_4 = {
  key: 1,
  class: "svg-30px"
}
const _hoisted_5 = {
  key: 0,
  class: "text-white bg-success",
  style: {"font-size":"10px","padding":"2px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check text-white",
  style: {"font-size":"10px"}
}, null, -1)
const _hoisted_7 = { dir: "ltr" }
const _hoisted_8 = {
  key: 0,
  class: "me-2",
  style: {"padding-top":"2px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fab fa-whatsapp text-success",
  style: {"font-size":"16px","margin-right":"3px"}
}, null, -1)
const _hoisted_10 = { class: "text-success" }
const _hoisted_11 = {
  key: 1,
  class: "me-2",
  style: {"padding-top":"2px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fab fa-whatsapp text-danger",
  style: {"font-size":"16px","margin-right":"3px"}
}, null, -1)
const _hoisted_13 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgSprite = _resolveComponent("SvgSprite")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form_item, {
      label: _ctx.hideLabel ? '' : _ctx.generalMethods.translate(_ctx.label),
      prop: _ctx.prop,
      rules: _ctx.rules,
      class: _normalizeClass(`${_ctx.elFormItemClassses}`),
      for: _ctx.id == null ? _ctx.prop : _ctx.id
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, _mergeProps({
          id: _ctx.id == null ? _ctx.prop : _ctx.id,
          ref: "mobileInputRef"
        }, _ctx.$attrs, {
          modelValue: _ctx.localModelValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModelValue) = $event)),
          autocomplete: _ctx.autocomplete,
          dir: "ltr",
          onInput: _cache[3] || (_cache[3] = 
					(value) => {
						_ctx.emitEvent('valueChanged', value);
					}
				),
          onChange: _cache[4] || (_cache[4] = 
					(value) => {
						_ctx.emitEvent('valueChanged', value);
					}
				),
          label: _ctx.ariaLabel,
          disabled: _ctx.disabled
        }), _createSlots({ _: 2 }, [
          (!_ctx.hidePrepend)
            ? {
                name: "prepend",
                fn: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_select, {
                    modelValue: _ctx.country,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.country) = $event)),
                    style: {"width":"85px"},
                    placeholder: _ctx.generalMethods.valueExist(_ctx.country) || _ctx.generalMethods.valueExist(_ctx.localModelValue, true) ? ' ' : _ctx.generalMethods.translate('select'),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateMobileFromCountry())),
                    "aria-label": "country code",
                    class: _normalizeClass([{ 'mobile-input-empty': !_ctx.generalMethods.valueExist(_ctx.country) }, { 'dark-and-white-select': _ctx.darkAndWhiteSelect }]),
                    "popper-class": "el-dropdown-50px text-center",
                    teleported: false
                  }, {
                    prefix: _withCtx(() => [
                      (_ctx.generalMethods.valueExist(_ctx.country))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _createVNode(_component_SvgSprite, {
                              symbol: _ctx.generalMethods.prepareSvgId(_ctx.country.english_name)
                            }, null, 8, ["symbol"])
                          ]))
                        : (_ctx.generalMethods.valueExist(_ctx.localModelValue, true))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                              _createVNode(_component_SvgSprite, { symbol: "nations_flag" })
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (countryOption, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          value: countryOption
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, [
                              _createVNode(_component_SvgSprite, {
                                symbol: _ctx.generalMethods.prepareSvgId(countryOption.english_name)
                              }, null, 8, ["symbol"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "class"]), [
                    [_vShow, !_ctx.hideList]
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["svg-38px", [{ 'd-inline-block': _ctx.hideList }, { 'd-none': !_ctx.hideList }]]),
                    style: {"min-width":"38px","padding-right":"15px"}
                  }, [
                    (_ctx.generalMethods.valueExist(_ctx.country))
                      ? (_openBlock(), _createBlock(_component_SvgSprite, {
                          key: 0,
                          symbol: _ctx.generalMethods.prepareSvgId(_ctx.country.english_name)
                        }, null, 8, ["symbol"]))
                      : (_ctx.generalMethods.valueExist(_ctx.localModelValue, true))
                        ? (_openBlock(), _createBlock(_component_SvgSprite, {
                            key: 1,
                            symbol: "nations_flag"
                          }))
                        : _createCommentVNode("", true)
                  ], 2)
                ]),
                key: "0"
              }
            : undefined
        ]), 1040, ["id", "modelValue", "autocomplete", "label", "disabled"])
      ]),
      _: 1
    }, 8, ["label", "prop", "rules", "class", "for"]),
    _createElementVNode("span", {
      class: "mobile-input-valid",
      style: _normalizeStyle(`${_ctx.generalMethods.valueExist(_ctx.validTextTop) ? 'top:' + _ctx.validTextTop + ';' : ''}`)
    }, [
      (
					_ctx.generalMethods.valueExist(_ctx.localModelValue) &&
					_ctx.generalMethods.valueExist(_ctx.country) &&
					_ctx.mobileValid &&
					_ctx.generalMethods.getMobileValidationLength(_ctx.generalMethods.getMobileValue(_ctx.localModelValue)) == _ctx.generalMethods.getMobileValue(_ctx.localModelValue).length
				)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.generalMethods.translate("valid")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_7, [
        (_ctx.whatsappIcon === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.generalMethods.translate("this_number_have_active_whatsapp")), 1)
            ]))
          : (_ctx.whatsappIcon === false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.generalMethods.translate("this_number_does_not_have_active_whatsapp")), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}